import { REMOTE_SLICE_ACTION } from '../lib/createRemoteSlice';
import { workspaceSettings } from '../overlays/workspaceSettings';
import { all } from 'redux-saga/effects';

export function* overlaysSagas() {
    yield all([`${REMOTE_SLICE_ACTION}:${workspaceSettings.name}:showMenu`]);
}
